export default __webpack_public_path__ + "static/media/GA.d748a6a0.svg";